import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[coinPreventRightClick]',
  standalone: true
})
export class PreventRightClickDirective {
  @HostListener('contextmenu', ['$event'])
  public onRightClick(e: MouseEvent): void {
    e.preventDefault();
  }
}
